import { InfiniteData } from 'react-query';

import { PageResultStock } from '@/core/request/PageResultStock';

export function flatInfiniteResult<T>(
  data: InfiniteData<Partial<PageResultStock<T>>> | undefined,
): T[] {
  if (!data || !data.pages.every((page) => !!page.result?.data)) return [];

  return (
    data?.pages.reduce<T[]>(
      (acc, curr) => [...acc, ...(curr.result?.data || [])],
      [],
    ) || []
  );
}
